if(window.jQuery){(function(){var variListItem='.collection-options > li';if($(variListItem)){function changeProductImage(image,variant_id,reset){var image=image||'';var variant_id=variant_id||'';var reset=reset||!1;var parentContainer=$(this).parents('.product__content');var productImageContainer=$(parentContainer).siblings('.product__image');var url=$('a',productImageContainer).data('o-url')+'?variant='+variant_id;if(reset===!0){image=$('img',productImageContainer).data('o-img');url=$('a',productImageContainer).data('o-url')}
$('a',productImageContainer).attr('href',url);$('h2 a',parentContainer).attr('href',url);$('img',productImageContainer).attr('src',image)}
$(variListItem).on('click',function(){$(this).siblings().removeClass('selected');$(this).toggleClass('selected')});$(variListItem).on('mouseenter',function(){changeProductImage.call(this,$(this).data('varimg'),$(this).data('var-id'));tippy(this,{placement:'bottom',content:$(this).data('variant_name'),hideOnClick:!1,theme:'zinus'})});$(variListItem).on('mouseleave',function(){if($(this).hasClass('selected')||$(this).siblings().hasClass('selected')){if($(this).hasClass('selected')){var image=$(this).data('varimg');var variation_id=$(this).data('var-id')}else{var image=$(this).siblings('.selected').data('varimg');var variation_id=$(this).siblings('.selected').data('var-id')}
changeProductImage.call(this,image,variation_id)}else{changeProductImage.call(this,'','',!0)}})}})();(function(){if($('.perc-amnt')&$('.actual-price')){const targetNode=$('.actual-price')[0];const config={childList:!0};const callback=function(mutationsList,observer){for(let mutation of mutationsList){if(mutation.type==='childList'){const percentOff=100-Math.round((parseFloat($('.actual-price').text().replace('$',''))/parseFloat($('.compared-price').text().replace('$','')))*100);$('.perc-amnt').text(percentOff)}}};const observer=new MutationObserver(callback);observer.observe(targetNode,config)}})();(function(){if($('#product-banner')[0]){var urlParams={};window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(m,key,value){urlParams[key]=value.toLowerCase()});function showBanner(banner){$(banner).show();$('#product-banner').slideDown(1000)}}})();(function(){$('.has-mega-menu > a').on('mouseover',function(){$(this).attr('aria-expanded','true')});$('.has-mega-menu > a').on('mouseout',function(){$(this).attr('aria-expanded','false')})})();$('.has-mega-menu').on('mouseover',function(){$('img:not(.loaded)',this).each(function(){$(this).attr('src',$(this).attr('menu-data-src'));$(this).addClass('loaded')})});}

// ========================================
// Discount Upsell Modal Functionality
// ========================================
(function() {
  'use strict';

  // Initialize Discount Upsell functionality
  function initDiscountUpsell() {
    const triggers = document.querySelectorAll('[data-discount-upsell-trigger]');
    const closeButtons = document.querySelectorAll('[data-discount-upsell-close]');
    const addButtons = document.querySelectorAll('[data-variant-add-btn], [data-discount-upsell-add]');
    const modalSubmitButtons = document.querySelectorAll('[data-discount-upsell-modal] [data-add-to-cart]');

    // Open modal
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const modalId = this.getAttribute('aria-controls');
        const modal = document.getElementById(modalId);
        if (modal) {
          openModal(modal);
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Close modal
    closeButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const modal = this.closest('[data-discount-upsell-modal]');
        if (modal) {
          closeModal(modal);
        }
      });
    });

    // Add to cart (modal and single-variant buttons)
    addButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const variantId = this.getAttribute('data-variant-id');
        if (variantId) {
          addToCart(variantId, this);
        }
      });
    });

    // Close modal after submitting add-to-cart form
    modalSubmitButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const modal = this.closest('[data-discount-upsell-modal]');
        if (modal) {
          setTimeout(function() {
            closeModal(modal);
          }, 300);
        }
      });
    });

    // Close modal on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const openModal = document.querySelector('[data-discount-upsell-modal][aria-hidden="false"]');
        if (openModal) {
          closeModal(openModal);
        }
      }
    });
  }

  function openModal(modal) {
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('discount-upsell-modal-open');
    
    // Focus first focusable element
    setTimeout(function() {
      const firstBtn = modal.querySelector('.discount-upsell-modal__add-btn, .discount-upsell-modal__close');
      if (firstBtn) {
        firstBtn.focus();
      }
    }, 100);
  }

  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('discount-upsell-modal-open');
    
    // Return focus to trigger
    const modalId = modal.id;
    const trigger = document.querySelector('[aria-controls="' + modalId + '"]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
  }

  function addToCart(variantId, button) {
    const originalText = button.textContent;
    button.classList.add('is-loading');
    button.textContent = 'Adding...';
    button.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId),
        quantity: 1
      })
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(function(data) {
      button.textContent = 'Added!';
      
      // Close modal after short delay
      setTimeout(function() {
        const modal = button.closest('[data-discount-upsell-modal]');
        if (modal) {
          closeModal(modal);
        }
        
        // Reset button state
        setTimeout(function() {
          button.classList.remove('is-loading');
          button.textContent = originalText;
          button.disabled = false;
        }, 300);
        
        // Refresh cart if theme has cart update method
        if (typeof window.theme !== 'undefined' && typeof window.theme.cart !== 'undefined' && typeof window.theme.cart.getCart === 'function') {
          window.theme.cart.getCart();
        }
        
        // Dispatch event for other components to listen
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: data } }));
        
        // Try to open cart drawer if available
        const cartDrawerTrigger = document.querySelector('[data-cart-toggle]');
        if (cartDrawerTrigger) {
          cartDrawerTrigger.click();
        }
      }, 800);
    })
    .catch(function(error) {
      console.error('Error adding to cart:', error);
      button.textContent = 'Error';
      
      setTimeout(function() {
        button.classList.remove('is-loading');
        button.textContent = originalText;
        button.disabled = false;
      }, 1500);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscountUpsell);
  } else {
    initDiscountUpsell();
  }

  // Re-initialize on Shopify section load/render (for theme editor)
  document.addEventListener('shopify:section:load', initDiscountUpsell);
})()

